import React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";

import Select from "react-select";

class WeekDaySelect extends React.Component {
  constructor(props) {
    super(props);
    let id = "";
    if (this.props.weekDay.dayTemplate !== null) {
      id = this.props.weekDay.dayTemplate.id;
    }

    this.state = {
      value: id
    };
  }

  handleSelectChange = async dayTemplate => {
    const id = this.props.weekDay.id;
    const dayTemplateId = dayTemplate.id;
    await this.props
      .updateWeekDayMutation({
        variables: { id, dayTemplateId }
      })
      .then(res => {
        this.props.refetch();
      })
      .catch(e => {
        console.error("update weekday", e);
      });
    this.setState({
      value: dayTemplateId
    });
  };

  render() {
    return (
      <Select
        value={this.state.value}
        onChange={v => this.handleSelectChange(v)}
        options={this.props.options}
        valueKey="id"
        clearable={false}
        labelKey="name"
        placeholder="Sélectionnez un template"
        wrapperStyle={{
          width: "90%"
        }}
      />
    );
  }
}

const UPDATE_WEEKDAY_MUTATION = gql`
  mutation UpdateWeekDayMutation($id: ID!, $dayTemplateId: ID!) {
    updateWeekDay(id: $id, dayTemplateId: $dayTemplateId) {
      id
    }
  }
`;

export default graphql(UPDATE_WEEKDAY_MUTATION, {
  name: "updateWeekDayMutation"
})(WeekDaySelect);



// WEBPACK FOOTER //
// ./src/components/utilities/WeekDaySelect.js